import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { emitter } from '@marvelapp/react-ab-test/index';
import rootReducer from '../reducers/index';
import analytics from '../middleware/analytics';
import { localStorageSyncer, localStorageSaver } from '../middleware/localStorage';

export default function configureStore(initialState) {
  const middlewares = [
    thunk,
    analytics,
    localStorageSyncer,
    localStorageSaver,
  ];
  window.novasolABTestsEmitter = emitter;
  return createStore(rootReducer, initialState, compose(
    applyMiddleware(...middlewares)
  ));
}
